import React, { useCallback, useContext, useEffect, useState } from "react";
import LoadingAction from "../../../themes/LoadingAction/LoadingAction";
import "./PagamentosSearch.css";
import { Button, Col, Input, Row, Table, Card, Tabs, Tag, Space, Statistic, Select, Checkbox, InputNumber } from "antd";
import { AuthContext } from "../../../contexts/AuthContext";
import { Link, useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import _, { debounce } from "lodash";
import axios from "axios";
import { useParams } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { DatePicker } from "antd";
import "antd/dist/antd.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
// Charts
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
} from "chart.js";
// PDF export
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import * as links from "../../../utils/links";
import {
  AiOutlineEdit,
  AiFillDelete,
  AiFillDollarCircle,
  AiOutlineRollback,
} from "react-icons/ai";
import qr_code_icon from "../../../assets/images/QR.png";
import notes from "../../../assets/images/notes.png";

ChartJS.register(ArcElement, ChartTooltip, Legend);

const PagamentosSearch = (props) => {
  const location = useLocation();
  const [maquinaInfos, setMaquinaInfos] = useState(location.state || {});
  const { setDataUser, loading, authInfo, setNotiMessage } =
    useContext(AuthContext);
    const { dataUser } = authInfo;
  let navigate = useNavigate();
  const token = authInfo?.dataUser?.token;
  const [isLoading, setIsLoading] = useState(false);
  // const [searchText, setsearchText] = useState('');
  const [searchText, setSearchText] = useState("");
  const [listCanals, setListCanals] = useState([]);
  const [estornos, setEstornos] = useState("");
  const [estoque, setEstoque] = useState("");
  const [cash, setCash] = useState("");
  const [total, setTotal] = useState("");
  const [loadingTable, setLoadingTable] = useState(false);
  const [dataInicio, setDataInicio] = useState(null);
  const [dataFim, setDataFim] = useState(null);
  const [dataMaquinas, setDataMaquinas] = useState(null);
  const [paymentDistribution, setPaymentDistribution] = useState({
    PIX: 0,
    CREDITO: 0,
    DEBITO: 0,
    ESPECIE: 0,
  });
  const [premioStats, setPremioStats] = useState({ quantidade: 0, valorMedio: 0 });
  const reportRef = React.useRef(null);
  const [filtroRapido, setFiltroRapido] = useState("periodo");
  // Filtros rápidos e ordenação
  const [filterTipo, setFilterTipo] = useState("TODOS");
  const [filterStatus, setFilterStatus] = useState("TODOS");
  const [premioOnly, setPremioOnly] = useState(false);
  const [valorMin, setValorMin] = useState(null);
  const [valorMax, setValorMax] = useState(null);
  const [identificador, setIdentificador] = useState("");
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);

  // const []
  const { id } = useParams();
  const { RangePicker } = DatePicker;
  useEffect(() => {
    getData(id);
    // getMaquinas(id)
  }, []);

  // Ler filtros do URL ao montar
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setFilterTipo(params.get("tipo") || "TODOS");
    setFilterStatus(params.get("status") || "TODOS");
    setPremioOnly(params.get("premio") === "1");
    setValorMin(params.get("min") ? Number(params.get("min")) : null);
    setValorMax(params.get("max") ? Number(params.get("max")) : null);
    setIdentificador(params.get("ident") || "");
    const sField = params.get("sortField");
    const sOrder = params.get("sortOrder");
    if (sField) setSortField(sField);
    if (sOrder) setSortOrder(sOrder);
    const start = params.get("start");
    const end = params.get("end");
    if (start) setDataInicio(start);
    if (end) setDataFim(end);
  }, []);

  useEffect(() => {
    if (dataFim != null) {
      getPaymentsPeriod(dataInicio, dataFim);
    }
  }, [dataFim]);

  // Persistir filtros e ordenação no URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    params.set("tipo", filterTipo);
    params.set("status", filterStatus);
    params.set("premio", premioOnly ? "1" : "0");
    if (valorMin != null) params.set("min", String(valorMin)); else params.delete("min");
    if (valorMax != null) params.set("max", String(valorMax)); else params.delete("max");
    if (identificador) params.set("ident", identificador); else params.delete("ident");
    if (sortField) params.set("sortField", sortField); else params.delete("sortField");
    if (sortOrder) params.set("sortOrder", sortOrder); else params.delete("sortOrder");
    if (dataInicio) params.set("start", dataInicio); else params.delete("start");
    if (dataFim) params.set("end", dataFim); else params.delete("end");
    navigate({ pathname: location.pathname, search: `?${params.toString()}` }, { replace: true, state: location.state });
  }, [filterTipo, filterStatus, premioOnly, valorMin, valorMax, identificador, sortField, sortOrder, dataInicio, dataFim]);

  const getData = (id) => {
    if (id.trim() !== "") {
      setLoadingTable(true);
      axios
        .get(`${process.env.REACT_APP_SERVIDOR}/pagamentos/${id}`, {
          headers: {
            "x-access-token": token,
            "content-type": "application/json",
          },
        })
        .then((res) => {
          setLoadingTable(false);
          setEstornos(res.data.estornos);
          setCash(res?.data?.cash);
          setEstoque(res?.data?.estoque);
          setTotal(res.data.total);
          setMaquinaInfos(prev => ({
            ...prev,
            store_id: res.data.store_id || prev.store_id
          }));
          if (res.status === 200 && Array.isArray(res.data.pagamentos)) {
            setListCanals(res.data.pagamentos);
          }
        })
        .catch((err) => {
          setLoadingTable(false);
          if ([401, 403].includes(err.response.status)) {
            // setNotiMessage('A sua sessão expirou, para continuar faça login novamente.');
            setNotiMessage({
              type: "error",
              message:
                "A sua sessão expirou, para continuar faça login novamente.",
            });
            if(dataUser.key === 'ADMIN'){
              navigate(links.ADMIN_SIGNIN)
              setDataUser(null);
            }else{
              navigate(links.SIGNIN)
              setDataUser(null);
            }
          }
        });
    }
  };

  const getMaquinas = (id) => {
    axios
      .get(`${process.env.REACT_APP_SERVIDOR}/maquinas`, {
        headers: {
          "x-access-token": token,
          "content-type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200 && Array.isArray(res.data)) {
          const maquinasData = res.data.find((item) => item.id === id);
          setDataMaquinas(maquinasData ?? null);
        } else {
          throw new Error();
        }
      })
      .catch((err) => {});
  };

  const getPaymentsPeriod = (dataInicio, dataFim) => { 
    if (id.trim() !== "") {
      setLoadingTable(true);
      const url = `${process.env.REACT_APP_SERVIDOR}/pagamentos-periodo/${id}`;
  
      const dataInicioISO = dataInicio
        ? moment(dataInicio).startOf("day").toISOString()
        : null;
      const dataFimISO = dataFim
        ? moment(dataFim).endOf("day").toISOString()
        : null;
  
      const requestBody = {};
      if (dataInicioISO) requestBody.dataInicio = dataInicioISO;
      if (dataFimISO) requestBody.dataFim = dataFimISO;
  
      axios
        .post(
          url,
          requestBody,
          {
            headers: {
              "x-access-token": token,
              "content-type": "application/json",
            },
          }
        )
        .then((res) => {
          setLoadingTable(false);
          setEstornos(res.data.estornos);
          setCash(res?.data?.cash);
          setTotal(res.data.total);
          setMaquinaInfos(prev => ({
            ...prev,
            store_id: res.data.store_id || prev.store_id
          }));
          if (res.status === 200 && Array.isArray(res.data.pagamentos)) {
            setListCanals(res.data.pagamentos);
            calculateDerivedStats(res.data.pagamentos);
          }
        })
        .catch((err) => {
          setLoadingTable(false);
          if ([401, 403].includes(err.response.status)) {
            setNotiMessage({
              type: "error",
              message:
                "A sua sessão expirou, para continuar faça login novamente.",
            });
            if(dataUser.key === 'ADMIN'){
              navigate(links.ADMIN_SIGNIN);
              setDataUser(null);
            } else {
              navigate(links.SIGNIN);
              setDataUser(null);
            }
          }
        });
    }
  };
  
  const mapTipoToCategoria = (tipo) => {
    switch (tipo) {
      case "bank_transfer":
      case "11":
        return "PIX";
      case "credit_card":
      case "prepaid_card":
      case "1":
        return "CREDITO";
      case "debit_card":
      case "8":
        return "DEBITO";
      case "CASH":
        return "ESPECIE";
      default:
        return null;
    }
  };

  const calculateDerivedStats = (items = []) => {
    const dist = { PIX: 0, CREDITO: 0, DEBITO: 0, ESPECIE: 0 };
    const premios = [];
    items.forEach((item) => {
      if (!item?.estornado) {
        if (item?.tipo === "saiu premio") {
          if (typeof item?.valor === "number") premios.push(item.valor);
        } else {
          const cat = mapTipoToCategoria(item?.tipo);
          if (cat && typeof item?.valor === "number") {
            dist[cat] += item.valor;
          }
        }
      }
    });
    setPaymentDistribution(dist);
    const qtd = premios.length;
    const soma = premios.reduce((a, b) => a + b, 0);
    setPremioStats({ quantidade: qtd, valorMedio: qtd ? soma / qtd : 0 });
  };

  const formatCurrency = (valor) =>
    new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
      valor || 0
    );

  const getPieChartData = () => {
    const labels = ["PIX", "Espécie", "Crédito", "Débito"];
    const dataVals = [
      paymentDistribution.PIX,
      paymentDistribution.ESPECIE,
      paymentDistribution.CREDITO,
      paymentDistribution.DEBITO,
    ];
    return {
      labels,
      datasets: [
        {
          label: "% por tipo",
          data: dataVals,
          backgroundColor: ["#2b6cb0", "#805ad5", "#38a169", "#dd6b20"],
          borderColor: ["#1e4f82", "#5b3b99", "#2a7a4d", "#a24d16"],
          borderWidth: 1,
        },
      ],
    };
  };

  // Dados filtrados conforme filtros rápidos
  const filteredData = React.useMemo(() => {
    let data = Array.isArray(listCanals) ? listCanals : [];
    const tipoMap = (tipo) => {
      const tipoValue = String(tipo || "").trim().toLowerCase();
      return tipoValue === "bank_transfer" || tipoValue === "11" || tipoValue === "account_money" || tipoValue === "conta mercado pago" || tipoValue === "pix"
        ? "PIX"
        : tipoValue === "cash"
        ? "ESPECIE"
        : tipoValue === "debit_card" || tipoValue === "8"
        ? "DEBITO"
        : tipoValue === "credit_card" || tipoValue === "prepaid_card" || tipoValue === "1"
        ? "CREDITO"
        : tipoValue === "saiu premio"
        ? "PREMIO"
        : null;
    };
    return data.filter((item) => {
      const normalized = tipoMap(item?.tipo);
      if (premioOnly && normalized !== "PREMIO") return false;
      if (filterTipo !== "TODOS" && normalized !== filterTipo) return false;
      const statusStr = item?.estornado ? "ESTORNADO" : "RECEBIDO";
      if (filterStatus !== "TODOS" && statusStr !== filterStatus) return false;
      if (valorMin != null && Number(item?.valor) < Number(valorMin)) return false;
      if (valorMax != null && Number(item?.valor) > Number(valorMax)) return false;
      if (
        identificador &&
        !String(item?.mercadoPagoId || "").toLowerCase().includes(identificador.toLowerCase())
      )
        return false;
      return true;
    });
  }, [listCanals, filterTipo, filterStatus, premioOnly, valorMin, valorMax, identificador]);

  const pieOptions = {
    plugins: {
      legend: { position: "bottom", labels: { color: "rgba(233, 242, 255, 0.9)" } },
      tooltip: {
        backgroundColor: "rgba(10, 18, 35, 0.92)",
        titleColor: "rgba(233, 242, 255, 0.92)",
        bodyColor: "rgba(233, 242, 255, 0.9)",
        callbacks: {
          label: function (ctx) {
            const dataset = ctx.dataset.data;
            const sum = dataset.reduce((a, b) => a + b, 0);
            const val = ctx.raw || 0;
            const pct = sum ? ((val / sum) * 100).toFixed(1) : 0;
            return `${ctx.label}: ${pct}% (${formatCurrency(val)})`;
          },
        },
      },
    },
  };

  const handleDownloadPDF = async () => {
    try {
      const element = reportRef.current;
      if (!element) return;
      const canvas = await html2canvas(element, { scale: 2 });
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(`relatorio-pagamentos.pdf`);
    } catch (e) {
      console.error("Erro ao gerar PDF", e);
    }
  };


  const columns = [
    {
      title: "Data",
      dataIndex: "data",
      key: "data",
      width: 500,
      sorter: (a, b) => new Date(a.data) - new Date(b.data),
      sortOrder: sortField === "data" ? sortOrder : null,
      render: (data) => (
        <span>{moment(data).format("DD/MM/YYYY HH:mm:ss")}</span>
      ),
    },
    {
      title: "Forma de pagamento",
      dataIndex: "tipo",
      key: "tipo",
      sorter: (a, b) => {
        const mapOrder = { PIX: 1, ESPECIE: 2, CREDITO: 3, DEBITO: 4, PREMIO: 5 };
        const toNorm = (t) => {
          const tipoValue = String(t || "").trim().toLowerCase();
          return tipoValue === "bank_transfer" || tipoValue === "11" || tipoValue === "account_money" || tipoValue === "conta mercado pago" || tipoValue === "pix"
            ? "PIX"
            : tipoValue === "cash"
            ? "ESPECIE"
            : tipoValue === "debit_card" || tipoValue === "8"
            ? "DEBITO"
            : tipoValue === "credit_card" || tipoValue === "prepaid_card" || tipoValue === "1"
            ? "CREDITO"
            : tipoValue === "saiu premio"
            ? "PREMIO"
            : "";
        };
        return (mapOrder[toNorm(a.tipo)] || 99) - (mapOrder[toNorm(b.tipo)] || 99);
      },
      sortOrder: sortField === "tipo" ? sortOrder : null,
      render: (tipo) => {
        const map = {
          PIX: { color: "geekblue", text: "PIX" },
          ESPECIE: { color: "purple", text: "Espécie" },
          DEBITO: { color: "orange", text: "Débito" },
          CREDITO: { color: "green", text: "Crédito" },
          PREMIO: { color: "volcano", text: "Prêmio" },
        };
        const tipoValue = String(tipo || "").trim().toLowerCase();
        if (tipoValue === "account_money" || tipoValue === "conta mercado pago") {
          return <Tag color="geekblue">Conta Mercado Pago</Tag>;
        }
        const normalized =
          tipoValue === "bank_transfer" || tipoValue === "11" || tipoValue === "pix"
            ? "PIX"
            : tipoValue === "cash"
            ? "ESPECIE"
            : tipoValue === "debit_card" || tipoValue === "8"
            ? "DEBITO"
            : tipoValue === "credit_card" || tipoValue === "prepaid_card" || tipoValue === "1"
            ? "CREDITO"
            : tipoValue === "saiu premio"
            ? "PREMIO"
            : null;
        const cfg = normalized ? map[normalized] : { color: "default", text: tipo };
        return <Tag color={cfg.color}>{cfg.text}</Tag>;
      },
    },
    {
      title: "Valor",
      dataIndex: "valor",
      key: "valor",
      sorter: (a, b) => a.valor - b.valor,
      sortOrder: sortField === "valor" ? sortOrder : null,
      render: (valor) =>
        new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(valor),
    },
    {
      title: "Identificador",
      dataIndex: "mercadoPagoId",
      key: "mercadoPagoId",
    },
    {
      title: "Status",
      dataIndex: "estornado",
      key: "status",
      width: 150,
      sorter: (a, b) => Number(a.estornado) - Number(b.estornado),
      sortOrder: sortField === "status" ? sortOrder : null,
      render: (estornado, record) =>
        estornado ? (
          <OverlayTrigger
            key={record.key}
            placement="top"
            overlay={
              <Tooltip id={`tooltip-top-${record.key}`}>
                {record.motivoEstorno ? record.motivoEstorno : "Sem motivo registrado"}
              </Tooltip>
            }
          >
            <Tag color="default" style={{ cursor: "pointer" }}>Estornado</Tag>
          </OverlayTrigger>
        ) : (
          <Tag color="success">Recebido</Tag>
        ),
    },
  ];

  const onRelatorioHandler = () => {
    if (!dataInicio || !dataFim) {
      setNotiMessage({
        type: "error",
        message:
          "Selecione no calendario a esquerda a data de inicio e firm para gerar o relatorio para essa maquina!",
      });
    } else {
      navigate(`${links.RELATORIO}/${id}`, {
        state: { maquinaInfos, dataInicio, dataFim },
      });
    }
  };

  const onRelatorioDispHandler = () => {
    navigate(`${links.RELATORIO_DISP}/${id}`, {
      state: { maquinaInfos, dataInicio, dataFim },
    });
  };

  return (
    <div className="PagamentosSearch_container">
      {isLoading && <LoadingAction />}
      <div className="PagamentosSearch_header">
        <div className="PagamentosSearch_header_left">
          <div className="Dashboard_staBlockTitle">{maquinaInfos?.nome}</div>
          <Space wrap>
            <Button
              className="PagamentosSearch_header_editBtn"
              onClick={() => {
                navigate(`${links.EDIT_FORNECEDOR_CANAIS}/${id}`, { state: location.state });
              }}
            >
              <AiOutlineEdit />
              <span>Editar</span>
            </Button>
            <Button
              className="PagamentosSearch_header_editBtn"
              onClick={() => {
                navigate(`${links.DELETE_FORNECEDOR_CANAIS}/${id}`, { state: location.state });
              }}
            >
              <AiFillDelete />
              <span>Excluir Pagamentos</span>
            </Button>
            <Button
              className="PagamentosSearch_header_editBtn"
              onClick={() => {
                navigate(links.REMOTE_CREDIT.replace(":id", id), { state: location.state });
              }}
            >
              <AiFillDollarCircle />
              <span>Crédito Remoto</span>
            </Button>
            <div className="PagamentosSearch_datePicker">
              <FontAwesomeIcon
                style={{ marginBottom: "10px", marginRight: "10px" }}
                icon={faSearch}
                onClick={() => getPaymentsPeriod(dataInicio, dataFim)}
              />
              <RangePicker
                style={{ border: "1px solid", borderRadius: "4px" }}
                placeholder={["Data Inicial", "Data Final"]}
                onChange={(dates, dateStrings) => {
                  setDataInicio(dateStrings ? dateStrings[0] : null);
                  setDataFim(dateStrings ? dateStrings[1] : null);
                }}
              />
            </div>
            <Button className="PagamentosSearch_header_editBtn" onClick={() => onRelatorioHandler()}>
              <img style={{ width: "15px", marginRight: "2px" }} src={notes} alt="notes" />
              <span>Relatório</span>
            </Button>
            <Button className="Admin_PagamentosSearch_header_editBtn" onClick={() => onRelatorioDispHandler()}>
              <img style={{ width: "15px", marginRight: "2px" }} src={notes} alt="notes" />
              <span>Relatório de Disponibilidade</span>
            </Button>
          <Button className="PagamentosSearch_header_back">
            <Link to={links.DASHBOARD_FORNECEDOR}><AiOutlineRollback style={{ marginRight: 6 }} />VOLTAR</Link>
          </Button>
          </Space>
        </div>
      </div>
      <div className="PagamentosSearch_body">
        <div className="PagamentosSearch_content" ref={reportRef}>
          <div className="metrics-grid">
            <Row gutter={[16, 16]}>
              <Col xs={24} md={12} lg={6}>
                <Card className="metric-card" bordered>
                  <Statistic title="Total" value={formatCurrency(total)} />
                </Card>
              </Col>
              <Col xs={24} md={12} lg={6}>
                <Card className="metric-card" bordered>
                  <Statistic title="Estornos" value={formatCurrency(estornos)} />
                </Card>
              </Col>
              <Col xs={24} md={12} lg={6}>
                <Card className="metric-card" bordered>
                  <Statistic title="Espécie" value={formatCurrency(cash)} />
                </Card>
              </Col>
              <Col xs={24} md={12} lg={6}>
                <Card className="metric-card" bordered>
                  <Statistic title="Estoque" value={estoque ?? "-"} />
                </Card>
              </Col>
            </Row>
            <div className="metrics-extra">
              <span className="metric-chip">Pulso: {formatCurrency(maquinaInfos.pulso)}</span>
              <span className="metric-chip">Store ID: {maquinaInfos.store_id ?? "-"}</span>
              <span className="metric-chip">Maquininha: {maquinaInfos.maquininha_serial ?? "-"}</span>
            </div>
            <div className="PagamentosSearch_maquina_stats_item">
              {maquinaInfos.store_id && (
                <Link target="_blank" to={`https://www.mercadopago.com.br/stores/detail?store_id=${maquinaInfos.store_id}`}>
                  <img className="PagamentosSearch_QR_Icon" src={qr_code_icon} alt="QR" />
                </Link>
              )}
            </div>
          </div>
          <div className="PagamentosSearch_description">{`${maquinaInfos?.nome} - ${maquinaInfos?.descricao}`}</div>

          <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
            <Col xs={24} md={12}>
              <Card title="Pagamentos por Tipo (percentual)">
                {Object.values(paymentDistribution).reduce((a, b) => a + b, 0) > 0 ? (
                  <Pie data={getPieChartData()} options={pieOptions} />
                ) : (
                  <div>Sem dados no período selecionado.</div>
                )}
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Tabs defaultActiveKey="premios">
                <Tabs.TabPane tab="Prêmios" key="premios">
                  <div style={{ display: "flex", gap: 24 }}>
                    <div>
                      <div style={{ fontWeight: 600 }}>Quantidade no período</div>
                      <div className="PagamentosSearch_nbList">{premioStats.quantidade}</div>
                    </div>
                    <div>
                      <div style={{ fontWeight: 600 }}>Valor médio</div>
                      <div className="PagamentosSearch_nbList">{formatCurrency(premioStats.valorMedio)}</div>
                    </div>
                  </div>
                </Tabs.TabPane>
              </Tabs>
              <div style={{ marginTop: 12 }}>
                <Button type="primary" onClick={handleDownloadPDF}>Baixar PDF do Relatório</Button>
              </div>
            </Col>
          </Row>

          {/* Filtros rápidos */}
          <Card style={{ marginBottom: 12 }} size="small" title="Filtros rápidos">
            <Space wrap>
              <Space direction="vertical" size={0}>
                <div style={{ fontSize: 12, color: 'rgba(233, 242, 255, 0.65)' }}>Tipo</div>
                <Select
                  value={filterTipo}
                  style={{ width: 160 }}
                  onChange={setFilterTipo}
                  options={[
                    { value: 'TODOS', label: 'Todos' },
                    { value: 'PIX', label: 'PIX' },
                    { value: 'ESPECIE', label: 'Espécie' },
                    { value: 'CREDITO', label: 'Crédito' },
                    { value: 'DEBITO', label: 'Débito' },
                    { value: 'PREMIO', label: 'Prêmio' },
                  ]}
                />
              </Space>
              <Space direction="vertical" size={0}>
                <div style={{ fontSize: 12, color: 'rgba(233, 242, 255, 0.65)' }}>Status</div>
                <Select
                  value={filterStatus}
                  style={{ width: 160 }}
                  onChange={setFilterStatus}
                  options={[
                    { value: 'TODOS', label: 'Todos' },
                    { value: 'RECEBIDO', label: 'Recebido' },
                    { value: 'ESTORNADO', label: 'Estornado' },
                  ]}
                />
              </Space>
              <Space direction="vertical" size={0}>
                <div style={{ fontSize: 12, color: 'rgba(233, 242, 255, 0.65)' }}>Prêmio</div>
                <Checkbox checked={premioOnly} onChange={(e) => setPremioOnly(e.target.checked)}>Somente prêmio</Checkbox>
              </Space>
              <Space direction="vertical" size={0}>
                <div style={{ fontSize: 12, color: 'rgba(233, 242, 255, 0.65)' }}>Faixa de valor</div>
                <Space>
                  <InputNumber
                    placeholder="Min"
                    value={valorMin}
                    onChange={setValorMin}
                    min={0}
                    style={{ width: 120 }}
                  />
                  <InputNumber
                    placeholder="Max"
                    value={valorMax}
                    onChange={setValorMax}
                    min={0}
                    style={{ width: 120 }}
                  />
                </Space>
              </Space>
              <Space direction="vertical" size={0}>
                <div style={{ fontSize: 12, color: '#6b7280' }}>Identificador</div>
                <Input
                  allowClear
                  placeholder="Buscar identificador"
                  value={identificador}
                  onChange={(e) => setIdentificador(e.target.value)}
                  style={{ width: 220 }}
                />
              </Space>
              <Button
                onClick={() => {
                  setFilterTipo('TODOS');
                  setFilterStatus('TODOS');
                  setPremioOnly(false);
                  setValorMin(null);
                  setValorMax(null);
                  setIdentificador('');
                  setSortField(null);
                  setSortOrder(null);
                }}
              >
                Limpar filtros
              </Button>
            </Space>
          </Card>

          <Table
            columns={columns}
            dataSource={filteredData}
            pagination={false}
            loading={loadingTable}
            onChange={(pagination, filters, sorter) => {
              const field = sorter.field || sorter.columnKey || null;
              const order = sorter.order || null;
              setSortField(field);
              setSortOrder(order);
            }}
            showSorterTooltip
            locale={{
              emptyText:
                identificador.trim() !== "" ? (
                  "-"
                ) : (
                  <div>Não foram encontrados resultados para sua pesquisa.</div>
                ),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default PagamentosSearch;
